/**
 * Inversa de la ofuscación que aplica el backend a `GET /bootstrap`
 * (`src/utils/bootstrap-obfuscation.ts` en el repo del backend).
 *
 * NO es cifrado: esta clave está en el bundle que descarga el navegador, así que
 * cualquiera puede deshacerlo. Solo evita que el contenido se lea en claro de un
 * vistazo en la pestaña Network. Lo que llega por aquí sigue siendo público, y
 * ahí solo debe viajar información que pueda serlo.
 *
 * Si se cambia la clave hay que cambiarla en el backend a la vez.
 */

const OBFUSCATION_KEY = 'avz-bootstrap-v1';

function xorBytes(input: Uint8Array): Uint8Array {
  const key = new TextEncoder().encode(OBFUSCATION_KEY);
  const output = new Uint8Array(input.length);
  for (let i = 0; i < input.length; i++) {
    output[i] = input[i] ^ key[i % key.length];
  }
  return output;
}

/** Cadena base64 ofuscada -> objeto. Lanza si el payload viene corrupto. */
export function deobfuscate<T>(payload: string): T {
  const binary = atob(payload);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return JSON.parse(new TextDecoder().decode(xorBytes(bytes))) as T;
}
